// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

// Custom controllers
import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TagsController from "./tags_controller"
application.register("tags", TagsController)

// Mission Steps drag-and-drop sorting
import MissionStepsSortController from "./mission_steps_sort_controller"
application.register("mission-steps-sort", MissionStepsSortController)

// Step progress (complete / uncomplete mission steps)
import StepProgressController from "./step_progress_controller"
application.register("step-progress", StepProgressController)

// Social Media Autocomplete
import SocialMediaAutocompleteController from "./social_media_autocomplete_controller"
application.register("social-media-autocomplete", SocialMediaAutocompleteController)

// Skills Autocomplete
import SkillsAutocompleteController from "./skills_autocomplete_controller"
application.register("skills-autocomplete", SkillsAutocompleteController)

// Password Validator
import PasswordValidatorController from "./password_validator_controller"
application.register("password-validator", PasswordValidatorController)

// Invite Emails (dynamic email fields)
import InviteEmailsController from "./invite_emails_controller"
application.register("invite-emails", InviteEmailsController)

// Startup Name Prompt (post-first-checkpoint modal)
import StartupNamePromptController from "./startup_name_prompt_controller"
application.register("startup-name-prompt", StartupNamePromptController)

// Startup Switcher (flightplan header dropdown)
import StartupSwitcherController from "./startup_switcher_controller"
application.register("startup-switcher", StartupSwitcherController)

// Mission step AI insights (lazy-loaded accordion)
import InsightController from "./insight_controller"
application.register("insight", InsightController)

// Auto-dismissing toast for "AI insights ready" notifications
import InsightToastController from "./insight_toast_controller"
application.register("insight-toast", InsightToastController)

// PRD source toggle (Apps: Competitive Analysis, Economic Intelligence)
import PrdSourceController from "./prd_source_controller"
application.register("prd-source", PrdSourceController)

// Inline title editing (report detail screens)
import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)
